import type Variants from "../types/Variants";

const getLoaderColor = (variant?: Variants): string => {
  switch (variant) {
    case "secondary":
    case "outline":
      return "border-foreground";
    case "ghost":
      return "border-border";
    default:
      return "border-white";
  }
};

export default getLoaderColor;
